import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { whenCurrentUserLoaded } from '@shared/guards/current-user-loaded';
import { SharedStore } from '@shared/store/shared.signal-store';
import { map } from 'rxjs';

export const changePasswordGuard: CanActivateFn = () => {
  const sharedStore = inject(SharedStore);
  const router = inject(Router);

  return whenCurrentUserLoaded().pipe(
    map(() => !sharedStore.isSsoOnly() || router.createUrlTree(['/'])),
  );
};
